import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import ListItem from './ListItem';

import { getTimezoneNameByCode, getOrderingNameByCode } from '../../../shared/Helpers';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  headerText: {
    textAlign: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  loadingSpinner: {
    margin: theme.spacing(5),
    height: 50,
    width: 50,
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(3 * 2))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
      maxWidth: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  list: {
    width: '100%',
  },
  loadingSpinnerContainer: {
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
  },
  nextPageContainer: {
    textAlign: 'center',
  },
});

class ClassList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const {
      classes,
      loading,
      pageLoading,
      niaclasses,
      userTimezone,
      currentDay,
      getNextPage,
      morePagesAvailable,
      ordering,
      handleShowOnMap,
    } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.appBarSpacer} />
        <div className={classes.headerText}>
          <Typography color="textSecondary">{'Showing times in ' + getTimezoneNameByCode(userTimezone)}</Typography>
          <Typography color="textSecondary">{'Sorted by ' + getOrderingNameByCode(ordering)}</Typography>
        </div>
        {loading
          ? (
            <Paper className={classes.paper} elevation={1}>
              <div className={classes.loadingSpinnerContainer}>
                <CircularProgress color="secondary" className={classes.loadingSpinner} />
              </div>
            </Paper>
          )
          : (
            <div>
              {niaclasses.length < 1
                ? (
                  <Typography variant="h6" className={classes.noTrainingsText}>Your search returned no Classes</Typography>
                )
                : (
                  <List className={classes.list}>
                    {niaclasses.map(c => (
                      <ListItem
                        key={c.id}
                        userTimezone={userTimezone}
                        classTimezone={c.timezone}
                        user={c.user}
                        currentClass={c}
                        currentDay={currentDay}
                        handleShowOnMap={handleShowOnMap}
                      />
                    ))}
                    <div className={classes.nextPageContainer}>
                      {pageLoading
                        ? (
                          <CircularProgress color="secondary" />
                        )
                        : (
                          <Button
                            onClick={getNextPage}
                            disabled={!morePagesAvailable}
                          >
                            Load More
                          </Button>
                        )
                      }
                    </div>
                  </List>
                )
              }
            </div>
          )
        }
      </div>
    );
  }
}

ClassList.propTypes = {
  currentDay: PropTypes.string.isRequired,
  getNextPage: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  pageLoading: PropTypes.bool.isRequired,
  niaclasses: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  userTimezone: PropTypes.string.isRequired,
  morePagesAvailable: PropTypes.bool.isRequired,
  ordering: PropTypes.string.isRequired,
  handleShowOnMap: PropTypes.func.isRequired,
};

export default withStyles(styles)(ClassList);
